var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('download-csv',{class:[
      _vm.isPrimaryButton ? 'button-gemnote' : 'whitebutton-gemnote',
      _vm.isGray ? 'gray' : '',
      _vm.buttonSize,
      _vm.withDataOk
    ],attrs:{"disabled":_vm.data.length <= 0,"fields":_vm.fields,"labels":_vm.labels,"data":_vm.data,"name":_vm.fileName,"type":"csv"}},[_c('span',{style:(_vm.customStyles)},[_vm._v(_vm._s(_vm.buttonLabel))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }